import type { Action, PlainAction } from './types';

export type WithRequired<Type, Key extends keyof Type> = Type & {
  [Property in Key]-?: Type[Property];
};

export function isPlainAction(action: Action): action is PlainAction {
  return typeof action === 'object' && action !== null && 'key' in action && 'label' in action;
}
